import { SxProps, Theme } from "@mui/material/styles";
import theme, { bleu } from "../../../theme";

const styles: SxProps<Theme> = [
  {
    "& .accueilBloc": {
      padding: 0,
      margin: "34px auto !important",
      [theme.breakpoints.down("sm")]: {
        padding: "0 1.25rem",
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: 900,
      },
      [theme.breakpoints.up("lg")]: {
        width: 1100,
      },
    },
    "& .accueilBlocEntete": {
      backgroundColor: "red",
    },
    "& .blocEnteteLogo": {
      marginTop: "-3.25rem !important",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    "& .blocEnteteSlogan": {
      paddingTop: "38px",
      paddingLeft: "50px",
      paddingBottom: "42px",
      [theme.breakpoints.down("sm")]: {
        paddingTop: 10,
        paddingLeft: 0,
        margin: "auto",
      },
      "& > h1": {
        fontSize: 24,
        fontWeight: "bold",
      },
    },
    "& .blocEnteteSousTitre": {
      fontSize: 24,
      marginBottom: "23px",
    },
    "& .blocEnteteAvantages": {
      flexWrap: "nowrap",
      "& :first-child": {
        marginLeft: 0,
      },
    },
    "& .blocEnteteAvantage": {
      marginLeft: "50px",
      display: "flex",
      alignItems: "center",
      fontSize: 18,
      [theme.breakpoints.down("sm")]: {
        marginLeft: "20px",
      },
    },
    "& .blocEntetePictoAvantages": {
      borderRadius: "50%",
      width: 25,
      height: 25,
      marginRight: 1,
    },
    "& .accueilBlocCCM": {
      margin: "35px auto",
      "& > h2": {
        margin: 0,
        marginBottom: "1.25rem",
      },
    },
    "& .accueilBlocDescriptif": {
      margin: "35px auto",
      color: theme.palette.common.black,
      "& > p ": {
        margin: "auto",
        marginTop: "2px",
        [theme.breakpoints.down("sm")]: {
          width: "90%",
        },
        [theme.breakpoints.up("md")]: {
          width: 900,
        },
      },
    },
    "& .accueilBlocTemoignages": {
      padding: "1.875rem 0",
    },
    "& .linkPlus": {
      textDecoration: "none",
      color: "#FFF",
      background: theme.palette.primary.main,
      borderRadius: "20px",
      padding: "8px 16px 10px 16px",
      fontWeight: "600",
      fontSize: 13,
      boxShadow: "1px 1px 3px 1px rgba(0, 0, 0, 0.4)",
    },
    "& .linkPlusBleu": {
      background: bleu,
      "&:hover, &:focus, &:active": {
        background: "#012644",
      },
    },
  },
];

export default styles;
